export const PROVIDERS_SEARCH_INPUT_CY_DATA = "providers-search-input";
export const PROVIDERS_SEARCH_BUTTON_CY_DATA = "providers-search-button";
export const PROVIDERS_GRID_CY_DATA = "providers-grid-input";
export const PROVIDERS_GRID_ITEM_CY_DATA = "providers-grid-item-input";
export const PROVIDERS_GRID_PAGINATION_CY_DATA = "pagination-input";
